import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { TITULAR } from "../data/legal";

function Page({ title, subtitle, children }) {
  return (
    <>
      <Navbar />
      <main className="bg-[#f5f1e8] pt-32 pb-20">
        <div className="max-w-3xl mx-auto px-6">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-[#7a6a48] hover:text-[#b59557] mb-8"
          >
            <ArrowLeft className="h-4 w-4" /> Volver al inicio
          </Link>
          <div className="text-[11px] tracking-[0.25em] uppercase text-[#b59557] mb-3">
            {subtitle}
          </div>
          <h1 className="font-serif font-medium text-[#1a1816] text-3xl md:text-5xl leading-tight mb-10">
            {title}
          </h1>
          <div className="legal-content text-[#3a3228] leading-relaxed space-y-5 text-[15px]">
            {children}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}

export function AvisoLegal() {
  return (
    <Page title="Aviso Legal" subtitle="Información del titular">
      <p>
        En cumplimiento con el deber de información recogido en artículo 10 de la Ley 34/2002, de
        11 de Julio, de Servicios de la Sociedad de la Información y del Comercio Electrónico, a
        continuación se reflejan los siguientes datos:
      </p>
      <div className="rounded-xl border border-[#e8ddc3] bg-white p-6 space-y-2">
        <p><strong>Titular:</strong> {TITULAR.nombre}</p>
        <p><strong>NIF:</strong> {TITULAR.nif}</p>
        <p><strong>Dirección:</strong> {TITULAR.direccion}</p>
        <p><strong>Email:</strong> <a href={`mailto:${TITULAR.email}`} className="text-[#b59557] underline">{TITULAR.email}</a></p>
        <p><strong>Teléfono:</strong> {TITULAR.telefono}</p>
        <p><strong>Web:</strong> {TITULAR.web}</p>
        <p><strong>Nombre comercial:</strong> {TITULAR.nombre_comercial}</p>
      </div>

      <h2 className="font-serif text-2xl text-[#1a1816] pt-4">Objeto</h2>
      <p>
        El presente aviso legal regula el uso y utilización del sitio web <strong>{TITULAR.web}</strong>,
        del que es titular {TITULAR.nombre}. La navegación por este sitio web atribuye la condición
        de usuario e implica la aceptación plena de todas las cláusulas aquí recogidas.
      </p>

      <h2 className="font-serif text-2xl text-[#1a1816] pt-4">Propiedad intelectual</h2>
      <p>
        Todos los contenidos, textos, imágenes, diseños, logotipos y código fuente del sitio web
        son propiedad del titular o de terceros que han autorizado su uso, y están protegidos por
        los derechos de propiedad intelectual e industrial. Queda prohibida su reproducción total o
        parcial sin autorización expresa.
      </p>

      <h2 className="font-serif text-2xl text-[#1a1816] pt-4">Responsabilidad</h2>
      <p>
        El titular no se hace responsable de los daños y perjuicios que pudieran derivarse de
        interferencias, omisiones, interrupciones, virus informáticos, averías telefónicas o
        desconexiones en el funcionamiento operativo del sistema electrónico, motivadas por causas
        ajenas al titular.
      </p>

      <h2 className="font-serif text-2xl text-[#1a1816] pt-4">Legislación aplicable</h2>
      <p>
        El presente aviso legal se rige por la legislación española. Para la resolución de cualquier
        controversia las partes se someten a los Juzgados y Tribunales de Badajoz, salvo que la
        legislación aplicable disponga otra cosa.
      </p>
    </Page>
  );
}

export function Privacidad() {
  return (
    <Page title="Política de Privacidad" subtitle="Protección de datos">
      <p>
        {TITULAR.nombre} (en adelante, "el Responsable") se compromete al cumplimiento del Reglamento
        (UE) 2016/679 General de Protección de Datos (RGPD) y la Ley Orgánica 3/2018, de Protección
        de Datos Personales y Garantía de los Derechos Digitales (LOPDGDD).
      </p>

      <h2 className="font-serif text-2xl text-[#1a1816] pt-4">Responsable del tratamiento</h2>
      <div className="rounded-xl border border-[#e8ddc3] bg-white p-5 space-y-1">
        <p>{TITULAR.nombre} · {TITULAR.nif}</p>
        <p>{TITULAR.direccion}</p>
        <p>Email: {TITULAR.email}</p>
      </div>

      <h2 className="font-serif text-2xl text-[#1a1816] pt-4">Finalidad del tratamiento</h2>
      <p>Los datos personales que nos facilites se tratarán para:</p>
      <ul className="list-disc pl-6 space-y-1">
        <li>Gestionar el pedido y el envío del producto.</li>
        <li>Enviarte la confirmación de pago y actualizaciones del estado del pedido.</li>
        <li>Dar respuesta a consultas realizadas a través del email o teléfono de contacto.</li>
        <li>Cumplir con las obligaciones legales, contables y fiscales aplicables.</li>
      </ul>

      <h2 className="font-serif text-2xl text-[#1a1816] pt-4">Legitimación</h2>
      <p>
        La base legal del tratamiento es la ejecución del contrato de compraventa y el consentimiento
        del interesado, así como el cumplimiento de obligaciones legales.
      </p>

      <h2 className="font-serif text-2xl text-[#1a1816] pt-4">Destinatarios y encargados de tratamiento</h2>
      <p>Los datos pueden ser comunicados a los siguientes encargados del tratamiento:</p>
      <ul className="list-disc pl-6 space-y-1">
        <li><strong>Stripe Payments Europe Ltd.</strong> (Irlanda) — procesamiento de pagos.</li>
        <li><strong>Resend, Inc.</strong> — envío de correos transaccionales.</li>
        <li>
          <strong>Google Ireland Limited</strong> — analítica web (Google Analytics 4), solo si
          aceptas las cookies de analítica. No se le comunican datos identificativos.
        </li>
        <li><strong>Emergent</strong> — hosting del sitio web.</li>
        <li><strong>MongoDB Atlas</strong> — almacenamiento de datos.</li>
        <li>Empresas de transporte, para la entrega del pedido.</li>
      </ul>

      <h2 className="font-serif text-2xl text-[#1a1816] pt-4">Conservación</h2>
      <p>
        Los datos se conservarán durante la relación comercial y, tras su finalización, durante los
        plazos legales exigidos para atender responsabilidades contables, fiscales y legales
        (normalmente 6 años).
      </p>

      <h2 className="font-serif text-2xl text-[#1a1816] pt-4">Derechos</h2>
      <p>
        Puedes ejercer tus derechos de acceso, rectificación, supresión, oposición, limitación del
        tratamiento y portabilidad enviando un correo a <strong>{TITULAR.email}</strong> indicando
        el derecho que deseas ejercer y adjuntando copia de tu DNI o documento identificativo.
      </p>
      <p>
        Tienes también derecho a presentar una reclamación ante la Agencia Española de Protección
        de Datos (<a href="https://www.aepd.es" target="_blank" rel="noreferrer" className="text-[#b59557] underline">www.aepd.es</a>)
        si consideras que el tratamiento no se ajusta a la normativa vigente.
      </p>

      <h2 className="font-serif text-2xl text-[#1a1816] pt-4">Seguridad</h2>
      <p>
        Hemos implementado las medidas técnicas y organizativas adecuadas para garantizar la
        seguridad de los datos personales, incluyendo cifrado HTTPS y almacenamiento en servidores
        con estándares de seguridad reconocidos.
      </p>
    </Page>
  );
}

export function Terminos() {
  return (
    <Page title="Términos y Condiciones" subtitle="Condiciones de contratación">
      <p>
        Las presentes Condiciones Generales de Contratación regulan la relación de compraventa a
        distancia entre {TITULAR.nombre}, con domicilio en {TITULAR.direccion} y NIF {TITULAR.nif}
        (en adelante, el "Vendedor"), y cualquier persona que realice un pedido a través del sitio
        web <strong>{TITULAR.web}</strong> (en adelante, el "Cliente").
      </p>

      <h2 className="font-serif text-2xl text-[#1a1816] pt-4">1. Producto</h2>
      <p>
        Ofrecemos retratos artísticos personalizados de mascotas impresos sobre tacos de madera
        blanca de 20×15×3 cm, a partir de una fotografía y el estilo seleccionado por el Cliente.
        Al tratarse de un producto <strong>personalizado a medida</strong>, se elabora específicamente
        tras recibir la foto y el pago.
      </p>

      <h2 className="font-serif text-2xl text-[#1a1816] pt-4">2. Precio y forma de pago</h2>
      <p>
        El precio del producto aparece claramente indicado en la web (29,50 € con envío incluido a
        Península). El precio incluye IVA. El pago se realiza mediante tarjeta bancaria a través de
        la pasarela segura de Stripe.
      </p>

      <h2 className="font-serif text-2xl text-[#1a1816] pt-4">3. Plazo de entrega</h2>
      <p>
        El plazo estimado de entrega es de <strong>3 a 5 días laborables</strong> desde la
        confirmación del pago, salvo causa de fuerza mayor o problemas con la foto aportada, en
        cuyo caso contactaremos con el Cliente.
      </p>

      <h2 className="font-serif text-2xl text-[#1a1816] pt-4">4. Envío</h2>
      <p>
        Los envíos se realizan a la dirección indicada por el Cliente en el formulario de pedido. El
        envío a Península está incluido en el precio. Para otros destinos, consulta por email.
      </p>

      <h2 className="font-serif text-2xl text-[#1a1816] pt-4">5. Derecho de desistimiento — Productos personalizados</h2>
      <div className="rounded-xl border border-[#e2d5b3] bg-[#efe6cf]/50 p-5">
        <p className="font-medium text-[#1a1816]">
          Al ser nuestro producto <strong>confeccionado conforme a las especificaciones del
          consumidor y claramente personalizado</strong>, está excluido del derecho de desistimiento
          de 14 días, de acuerdo con el art. 103.c) del Real Decreto Legislativo 1/2007, de 16 de
          noviembre, por el que se aprueba el texto refundido de la Ley General para la Defensa de
          los Consumidores y Usuarios.
        </p>
        <p className="mt-3">
          Por tanto, <strong>NO se aceptan devoluciones</strong> ni cambios una vez realizado el
          pedido. Al confirmar la compra, el Cliente acepta expresamente esta condición.
        </p>
      </div>

      <h2 className="font-serif text-2xl text-[#1a1816] pt-4">6. Producto defectuoso o incidencias</h2>
      <p>
        Si el producto llega dañado, presenta algún defecto de impresión o acabado imputable a
        nosotros, el Cliente dispone de 14 días naturales desde la recepción para contactar con
        nosotros a <strong>{TITULAR.email}</strong>. Comprobada la incidencia, procederemos a la
        reposición del producto sin coste adicional.
      </p>

      <h2 className="font-serif text-2xl text-[#1a1816] pt-4">7. Contenido de la fotografía</h2>
      <p>
        El Cliente garantiza disponer de todos los derechos sobre la fotografía que facilita y que
        su uso para la elaboración del retrato no infringe derechos de terceros, eximiendo al
        Vendedor de cualquier reclamación al respecto.
      </p>

      <h2 className="font-serif text-2xl text-[#1a1816] pt-4">8. Legislación y jurisdicción</h2>
      <p>
        Las presentes condiciones se rigen por la legislación española. En caso de controversia, las
        partes se someten a los Juzgados y Tribunales de Badajoz, salvo que la legislación vigente
        disponga otra cosa.
      </p>

      <h2 className="font-serif text-2xl text-[#1a1816] pt-4">9. Contacto</h2>
      <p>
        Para cualquier consulta relativa al pedido o a estas condiciones:
      </p>
      <ul className="list-disc pl-6 space-y-1">
        <li>Email: <a href={`mailto:${TITULAR.email}`} className="text-[#b59557] underline">{TITULAR.email}</a></li>
        <li>Teléfono: {TITULAR.telefono}</li>
      </ul>
    </Page>
  );
}

export function Cookies() {
  return (
    <Page title="Política de Cookies" subtitle="Uso de cookies">
      <p>
        Este sitio web utiliza cookies y tecnologías similares para garantizar su correcto
        funcionamiento y mejorar tu experiencia de navegación, conforme al RGPD y a la LSSI.
      </p>

      <h2 className="font-serif text-2xl text-[#1a1816] pt-4">¿Qué son las cookies?</h2>
      <p>
        Las cookies son pequeños archivos que se almacenan en tu dispositivo al visitar un sitio
        web. Permiten recordar información sobre tu visita para facilitar tu próxima navegación y
        hacer que el sitio sea más útil.
      </p>

      <h2 className="font-serif text-2xl text-[#1a1816] pt-4">Cookies que utilizamos</h2>
      <div className="rounded-xl border border-[#e8ddc3] bg-white overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#efe6cf]/60">
            <tr>
              <th className="text-left p-3">Cookie</th>
              <th className="text-left p-3">Tipo</th>
              <th className="text-left p-3">Finalidad</th>
              <th className="text-left p-3">Duración</th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-t border-[#e8ddc3]">
              <td className="p-3">rm_cookie_consent</td>
              <td className="p-3">Técnica</td>
              <td className="p-3">Recuerda tu preferencia sobre cookies</td>
              <td className="p-3">12 meses</td>
            </tr>
            <tr className="border-t border-[#e8ddc3]">
              <td className="p-3">__stripe_mid / __stripe_sid</td>
              <td className="p-3">Stripe (Terceros)</td>
              <td className="p-3">Procesamiento de pagos y prevención de fraude</td>
              <td className="p-3">1 año / 30 min</td>
            </tr>
            <tr className="border-t border-[#e8ddc3]">
              <td className="p-3">_ga / _ga_FZ46MFZSP2</td>
              <td className="p-3">Analítica · Google (Terceros)</td>
              <td className="p-3">
                Google Analytics 4: medir visitas, procedencia y pasos del pedido de forma
                agregada. Solo con tu consentimiento.
              </td>
              <td className="p-3">2 años</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p className="text-sm text-[#7a6a48]">
        Las cookies técnicas se activan siempre porque son necesarias para el funcionamiento del
        sitio y el procesamiento seguro de los pagos. Las cookies de analítica de Google Analytics 4
        (Google Ireland Limited) solo se cargan si las aceptas expresamente. Hemos desactivado las
        señales publicitarias y la personalización de anuncios, y nunca enviamos a Google fotos,
        nombres, correos, teléfonos ni direcciones. Google puede tratar datos técnicos fuera del
        EEE con las garantías adecuadas (cláusulas contractuales tipo y Marco de Privacidad de
        Datos UE-EE. UU.). No utilizamos cookies publicitarias.
      </p>

      <h2 className="font-serif text-2xl text-[#1a1816] pt-4">Configuración y revocación del consentimiento</h2>
      <p>
        Puedes aceptar, rechazar o configurar las cookies de analítica desde el banner que aparece
        al entrar por primera vez en la web. Puedes cambiar de opinión o retirar tu consentimiento
        en cualquier momento desde el enlace &laquo;Configurar cookies&raquo; del pie de página;
        al retirarlo, dejamos de cargar Google Analytics y eliminamos sus cookies. También puedes
        gestionar o eliminar las cookies desde la configuración de tu navegador.
      </p>
    </Page>
  );
}
